// ===== HOA THEO DỊP =====
export const hoaTheoDip = [
  // Kỷ niệm (flower7–18)
  {
    id: "dip-1", ma: "flower7.webp", ten: "Chân Thành", dip: "ki-niem", gia: 180000,
    thanhPhan: "- Cẩm tú cầu xanh bơ: 3",
    moTa: "Chân Thành là biểu tượng của sự bền chặt và lòng tin tưởng tuyệt đối qua dòng chảy thời gian. Ba đóa cẩm tú cầu xanh bơ mang sắc thái dịu mát, đại diện cho sự hòa hợp, thấu hiểu và một tình yêu luôn tươi mới như thuở ban đầu. Con số 3 còn mang ý nghĩa về sự gắn kết giữa Quá khứ - Hiện tại - Tương lai, là lời khẳng định về một hành trình chung đầy trân trọng.",
  },
  {
    id: "dip-2", ma: "flower8.webp", ten: "Cappuccino Vintage", dip: "ki-niem", gia: 250000,
    thanhPhan: "- Cẩm chướng chùm trắng: 3\n- Hồng capuchino: 4\n- Đồng tiền kem nhí: 3",
    moTa: "Cappuccino Vintage mang vẻ đẹp đầy lôi cuốn và hoài niệm với tông màu nâu kem đặc trưng của những đóa hồng Cappuccino. 4 đóa hồng chủ đạo gửi gắm thông điệp về một tình cảm nồng nàn, sâu sắc và bền vững theo thời gian. Sự kết hợp cùng cẩm chướng chùm trắng tinh khôi và đồng tiền kem nhí tạo nên tổng thể hài hòa, sang trọng, cổ điển.",
  },
  {
    id: "dip-3", ma: "flower9.webp", ten: "Roseberry", dip: "ki-niem", gia: 300000,
    thanhPhan: "- Green bell: 2\n- Hoa thạch thảo tím: 2\n- Hồng da: 10",
    moTa: "Roseberry là bản giao hưởng của sự thủy chung và lòng trân quý. Với 10 đóa hồng da làm chủ đạo, bó hoa tôn vinh một tình yêu bền chặt, đằm thắm và sự ngưỡng mộ sâu sắc. Sắc tím dịu dàng của thạch thảo đan xen cùng nét thanh mảnh của Green bell tạo nên chiều sâu nghệ thuật, đại diện cho lời hứa gắn kết vĩnh cửu.",
  },
  {
    id: "dip-4", ma: "flower10.webp", ten: "Sweet Anniversary", dip: "ki-niem", gia: 550000,
    thanhPhan: "- Cẩm chướng chùm hồng sen: 5\n- Cẩm chướng đơn viền tím: 7\n- Hồng da: 5\n- Purple Ohara: 5",
    moTa: "Lấy cảm hứng từ những rung động nhẹ nhàng trong tình yêu, Sweet Anniversary mang tone hồng pastel nữ tính và thanh lịch. Sự hòa quyện giữa cẩm chướng hồng sen mềm mại, cẩm chướng viền tím tinh tế, hồng da ngọt ngào cùng Purple Ohara sang trọng tạo nên tổng thể vừa lãng mạn vừa cuốn hút — món quà kỷ niệm hoàn hảo để thay lời yêu thương.",
  },
  {
    id: "dip-5", ma: "flower11.webp", ten: "Whisper of Nature", dip: "ki-niem", gia: 600000,
    thanhPhan: "- Cúc Tana: 3\n- Green wicky: 3\n- Hồng trắng cồ: 13\n- Scabiosa trắng: 3\n- Sen đá size trung: 1",
    moTa: "Whisper of Nature là biểu tượng của sự gắn kết bền bỉ và lòng chân thành tuyệt đối. Với các đóa hồng trắng cồ tinh khôi kết hợp cùng một nhành sen đá kiên cường, bó hoa tôn vinh những mối quan hệ vững chãi, vượt qua mọi thử thách của thời gian. Đây là món quà kỷ niệm đầy chiều sâu cho những tình cảm trân quý nhất.",
  },
  {
    id: "dip-6", ma: "flower12.webp", ten: "Mây Hồng Dịu Ngọt", dip: "ki-niem", gia: 700000,
    thanhPhan: "- Cẩm tú cầu hồng: 3",
    moTa: "Bó hoa cẩm tú cầu hồng pastel mang vẻ đẹp nhẹ nhàng và tinh tế, như một áng mây mềm mại phủ sắc hồng dịu. Hoa cẩm tú cầu tượng trưng cho tình yêu thuần khiết và lòng biết ơn chân thành. Đây là món quà lý tưởng để gửi tặng trong ngày kỷ niệm, như một lời nhắn: vì bạn xứng đáng được yêu thương.",
  },
  {
    id: "dip-7", ma: "flower13.webp", ten: "Harmony of Gratitude", dip: "ki-niem", gia: 750000,
    thanhPhan: "- Hoa baby: 1\n- Hồng da: 5\n- Hồng shimmer DL: 5\n- Hồng tím cà: 5\n- Hồng trắng cồ: 5\n- Hồng trứng gà: 5",
    moTa: "Harmony of Gratitude là bản hòa ca của lòng tri ân, kết tinh từ 25 đóa hồng mang những sắc thái rực rỡ nhất. Sự kết hợp giữa sắc trắng tinh khôi, hồng Shimmer ngọt ngào và tím cà quý phái tượng trưng cho sự trân trọng, thấu hiểu và gắn kết bền lâu.",
  },
  {
    id: "dip-8", ma: "flower14.webp", ten: "Eternal Flame", dip: "ki-niem", gia: 1000000,
    thanhPhan: "- Hồng đỏ Ecuador DL: 30",
    moTa: "Eternal Flame là biểu tượng của một tình yêu nồng cháy, mãnh liệt và không bao giờ lụi tàn với sự hiện diện của 30 đóa hồng đỏ Ecuador kiêu sa. Con số 30 mang ý nghĩa về một tình cảm chân thành, trọn vẹn và sự tin tưởng tuyệt đối. Đây là món quà kỷ niệm đầy đẳng cấp, thay lời khẳng định rằng trái tim này vẫn luôn hướng về bạn.",
  },
  {
    id: "dip-9", ma: "flower15.webp", ten: "Sunset Glow", dip: "ki-niem", gia: 1100000,
    thanhPhan: "- Cẩm chướng đơn cam: 10\n- Green bell: 2\n- Hồng đỏ Ecuador DL: 15\n- Lan Moka vàng nến: 5\n- Lan Moka đỏ: 5\n- Sen đá lớn: 1",
    moTa: "Sunset Glow là một tuyệt tác rực rỡ, tượng trưng cho sự thịnh vượng và nguồn năng lượng bền bỉ trong mối quan hệ. Sắc cam đỏ của hoàng hôn hòa quyện cùng nét thanh thoát của lan Moka tạo nên một bó hoa kỷ niệm lý tưởng, dành tặng đối tác và tri ân những chặng đường dài đã cùng nhau vượt qua.",
  },
  {
    id: "dip-10", ma: "flower16.webp", ten: "Giấc Mơ Thạch Anh", dip: "ki-niem", gia: 1250000,
    thanhPhan: "- Cẩm chướng đơn viền tím: 10\n- Cát tường hồng viền: 2\n- Cúc calimero trắng: 5\n- Hoa baby: 1\n- Hồng song hỷ cồ: 10\n- Thúy châu trắng: 3",
    moTa: "Giấc Mơ Thạch Anh mang vẻ đẹp thanh lịch và đầy chất thơ với tông màu tím hồng dịu dàng. Bó hoa là lời chúc mừng kỷ niệm đầy tinh tế, tôn vinh một tình cảm luôn tươi mới và tràn đầy hy vọng như những viên thạch anh lấp lánh.",
  },
  {
    id: "dip-11", ma: "flower17.webp", ten: "Pink Romance", dip: "ki-niem", gia: 1300000,
    thanhPhan: "- Hồng hồng Ecuador cồ: 20\n- Hoa baby: 1\n- Lá khuynh diệp: 5",
    moTa: "Pink Romance là bản tình ca bất tận của những đóa hồng hồng Ecuador kiêu sa, mỗi cánh hoa như một trang thơ lãng mạn. Sắc hồng nồng nàn tượng trưng cho tình yêu đằm thắm, luôn tươi mới và đong đầy cảm xúc. Bó hoa là lời khẳng định cho một tình cảm chân thành, xứng đáng được nâng niu và trân trọng mãi mãi.",
  },
  {
    id: "dip-12", ma: "flower18.webp", ten: "Century of Love", dip: "ki-niem", gia: 2200000,
    thanhPhan: "- Hồng đỏ Ecuador cồ: 50\n- Hoa baby: 2\n- Lá khuynh diệp: 8",
    moTa: "Century of Love là tuyên ngôn tình yêu hoành tráng nhất — 50 đóa hồng đỏ Ecuador cồ kiêu hãnh kết thành một bó hoa đẳng cấp, tượng trưng cho một thế kỷ yêu thương không bao giờ phai nhạt. Đây là món quà kỷ niệm xa hoa, dành riêng cho những người xứng đáng nhận được điều tốt đẹp nhất trong cuộc đời.",
  },
  // Sinh nhật (flower19–24)
  {
    id: "dip-13", ma: "flower19.webp", ten: "Pinky Muse", dip: "sinh-nhat", gia: 150000,
    thanhPhan: "- Cúc mẫu đơn hồng nhạt: 1\n- Hoa baby: 1",
    moTa: "Pinky Muse là sự kết tinh của nét đẹp tối giản nhưng đầy chiều sâu, nơi một đóa cúc mẫu đơn hồng nhạt duy nhất tỏa sáng như một nữ hoàng kiêu sa ở vị trí trung tâm. Bó hoa là lựa chọn hoàn hảo để gửi gắm sự trân trọng và cầu chúc cho một tuổi mới luôn rạng ngời.",
  },
  {
    id: "dip-14", ma: "flower20.webp", ten: "Nắng Mai", dip: "sinh-nhat", gia: 200000,
    thanhPhan: "- Cúc Tana: 3\n- Hồng da: 5",
    moTa: "Nắng Mai là sự giao thoa ngọt ngào giữa vẻ đẹp cổ điển và nét hiện đại. 5 đóa hồng da mịn màng điểm xuyết cùng cúc Tana nhỏ xinh tựa như những mặt trời tí hon, mang theo lời chúc về một tình bạn bền chặt và một tuổi mới luôn rạng rỡ, bình yên.",
  },
  {
    id: "dip-15", ma: "flower21.webp", ten: "Azure Dream", dip: "sinh-nhat", gia: 350000,
    thanhPhan: "- Cẩm tú cầu xanh: 5",
    moTa: "Tựa như một khoảng trời bình yên được gói ghém lại, Azure Dream mang đến sắc xanh dịu mắt của những đóa cẩm tú cầu bồng bềnh như mây. Không rực rỡ phô trương, bó hoa là món quà sinh nhật tinh tế dành tặng những tâm hồn yêu thích nét đẹp giản đơn, thanh khiết.",
  },
  {
    id: "dip-16", ma: "flower22.webp", ten: "The Pure Harmony", dip: "sinh-nhat", gia: 650000,
    thanhPhan: "- Cát tường xanh: 4\n- Cúc calimero trắng: 5\n- Hồng trắng cồ: 7",
    moTa: "The Pure Harmony là một bó hoa mang hơi thở của thiên nhiên với sự đan xen hoàn hảo giữa sắc trắng tinh khôi và xanh lá tươi mát. Bó hoa không chỉ là một món quà sinh nhật mà còn thể hiện phong cách sống tinh tế, hiện đại và gần gũi với thiên nhiên.",
  },
  {
    id: "dip-17", ma: "flower23.webp", ten: "Blush Harmony", dip: "sinh-nhat", gia: 480000,
    thanhPhan: "- Hồng phấn: 8\n- Cẩm chướng hồng sen: 5\n- Hoa baby: 1",
    moTa: "Blush Harmony là sự hòa quyện ngọt ngào của sắc hồng phấn dịu dàng, tạo nên một bó hoa sinh nhật nữ tính và đầy lãng mạn. Những đóa hồng phấn tượng trưng cho sự ngưỡng mộ chân thành và lời chúc mừng ấm áp nhất dành cho ngày đặc biệt của người thân yêu.",
  },
  {
    id: "dip-18", ma: "flower24.webp", ten: "Nắng Hồng Rạng Rỡ", dip: "sinh-nhat", gia: 520000,
    thanhPhan: "- Hướng dương mini: 3\n- Hồng vàng: 5\n- Cúc Tana cam: 3\n- Lá xanh phụ",
    moTa: "Nắng Hồng Rạng Rỡ bừng sáng như một buổi bình minh tươi vui, mang theo sắc vàng cam rực rỡ của hướng dương và hồng vàng. Bó hoa là lời chúc mừng sinh nhật tràn đầy năng lượng, cầu chúc một tuổi mới rạng ngời, hạnh phúc và luôn hướng về phía mặt trời.",
  },
  // Khai trương (flower25–30)
  {
    id: "dip-19", ma: "flower25.webp", ten: "Hoàng Kim Khai Lộ", dip: "khai-truong", gia: 750000,
    thanhPhan: "- Hướng dương: 5\n- Hoa ly vàng: 3\n- Lá khuynh diệp: 5",
    moTa: "Hoàng Kim Khai Lộ là biểu tượng của sự thịnh vượng và khởi đầu rực rỡ. Những đóa hướng dương vàng tươi kết hợp cùng hoa ly sang trọng mang ý nghĩa về một sự nghiệp phát đạt, luôn hướng về phía ánh sáng và thành công vượt bậc trên con đường mới.",
  },
  {
    id: "dip-20", ma: "flower26.webp", ten: "Vạn Lộc Khai Hoa", dip: "khai-truong", gia: 850000,
    thanhPhan: "- Hoa cúc vàng: 10\n- Hồng đỏ: 5\n- Cát tường trắng: 3\n- Lá phụ",
    moTa: "Vạn Lộc Khai Hoa kết hợp sắc vàng và đỏ — màu sắc của may mắn và thịnh vượng trong văn hóa Á Đông. Bó hoa là lời chúc mừng khai trương ý nghĩa, mang đến nguồn năng lượng tích cực và vạn điều hanh thông cho chặng đường kinh doanh mới.",
  },
  {
    id: "dip-21", ma: "flower27.webp", ten: "Tĩnh Lam", dip: "khai-truong", gia: 650000,
    thanhPhan: "- Cẩm tú cầu xanh: 3\n- Hoa lan xanh: 2 cành\n- Lá khuynh diệp: 5",
    moTa: "Tĩnh Lam mang vẻ đẹp thanh thoát và quý phái với sắc xanh tươi mát, tượng trưng cho sự bình tĩnh, trí tuệ và thành công bền vững. Bó hoa là lời chúc cho một không gian kinh doanh văn minh, thu hút khách hàng và đối tác lâu dài.",
  },
  {
    id: "dip-22", ma: "flower28.webp", ten: "Xuân Phát", dip: "khai-truong", gia: 1200000,
    thanhPhan: "- Lan hồ điệp trắng: 3 cành\n- Hồng vàng: 10\n- Cẩm chướng cam: 5\n- Lá khuynh diệp",
    moTa: "Xuân Phát mang vẻ đẹp sang trọng và quý phái với lan hồ điệp trắng — biểu tượng của sự thanh cao và thịnh vượng. Bó hoa là món quà khai trương cao cấp, gửi gắm lời chúc cho một khởi đầu phát đạt, vạn sự như ý và sự nghiệp ngày càng hưng thịnh.",
  },
  {
    id: "dip-23", ma: "flower29.webp", ten: "Sắc Nắng", dip: "khai-truong", gia: 1400000,
    thanhPhan: "- Hồng cam Ecuador: 15\n- Hướng dương: 5\n- Cẩm chướng cam: 8\n- Lá bạc: 5",
    moTa: "Sắc Nắng bừng sáng với sắc cam rực rỡ, mang theo năng lượng của mặt trời và tinh thần lạc quan không ngừng. Đây là bó hoa khai trương đầy ấn tượng, tượng trưng cho sự nhiệt huyết, sáng tạo và thành công rực rỡ trên con đường sự nghiệp.",
  },
  {
    id: "dip-24", ma: "flower30.webp", ten: "Victory Aura", dip: "khai-truong", gia: 1600000,
    thanhPhan: "- Hồng đỏ Ecuador DL: 20\n- Hoa lily cam: 5\n- Hướng dương: 3\n- Lá bạc: 5",
    moTa: "Victory Aura là bó hoa khai trương đẳng cấp, kết hợp hồng đỏ kiêu sa với lily cam rực rỡ và hướng dương tươi vui. Đây là lời chúc mừng hoành tráng cho một cửa hàng mới, một văn phòng mới, một chặng đường kinh doanh đầy hứa hẹn và vinh quang.",
  },
  // Chia buồn (flower31–36)
  {
    id: "dip-25", ma: "flower31.webp", ten: "Silent Farewell", dip: "chia-buon", gia: 600000,
    thanhPhan: "- Hoa cúc trắng: 15\n- Hoa baby trắng: 200g\n- Lá khuynh diệp xanh",
    moTa: "Silent Farewell mang vẻ đẹp thuần khiết và bình yên của sắc trắng. Những đóa cúc trắng tinh khôi là biểu tượng của sự trong sáng, thanh thản và lời chia sẻ chân thành nhất trong lúc đau buồn. Bó hoa là sự đồng hành lặng lẽ nhưng đầy ý nghĩa.",
  },
  {
    id: "dip-26", ma: "flower32.webp", ten: "Lasting Memory", dip: "chia-buon", gia: 700000,
    thanhPhan: "- Hoa cúc trắng: 10\n- Cẩm chướng trắng: 5\n- Hoa đồng tiền trắng: 3\n- Lá phụ",
    moTa: "Lasting Memory là bó hoa chia buồn mang màu trắng thanh tịnh, kết hợp nhiều loại hoa trắng tinh khôi. Mỗi bông hoa là một lời cầu nguyện chân thành, một lời chia sẻ sâu sắc trong khoảnh khắc đau thương nhất — ký ức về người thân yêu sẽ mãi còn đó.",
  },
  {
    id: "dip-27", ma: "flower33.webp", ten: "Remembrance", dip: "chia-buon", gia: 800000,
    thanhPhan: "- Hoa lan trắng: 2 cành\n- Cúc trắng: 8\n- Hoa baby trắng: 100g\n- Lá khuynh diệp",
    moTa: "Remembrance là sự kết hợp thanh lịch giữa lan trắng quý phái và cúc trắng bình dị, tạo nên một bó hoa chia buồn đầy trang trọng. Đây là lời chia sẻ thầm lặng nhưng đầy ý nghĩa, gửi gắm sự đồng cảm và yêu thương trong những ngày khó khăn nhất.",
  },
  {
    id: "dip-28", ma: "flower34.webp", ten: "Resting Heart", dip: "chia-buon", gia: 1100000,
    thanhPhan: "- Hoa cúc trắng: 20\n- Lan hồ điệp trắng: 1 cành\n- Hoa baby trắng: 200g",
    moTa: "Resting Heart là bó hoa chia buồn cao cấp, kết hợp lan hồ điệp trắng thanh cao với cúc trắng thuần khiết. Bó hoa gửi gắm lời cầu nguyện bình yên và lời an ủi chân thành nhất đến những trái tim đang đau, mong người ra đi được an nghỉ trong thái bình.",
  },
  {
    id: "dip-29", ma: "flower35.webp", ten: "Gentle Path", dip: "chia-buon", gia: 1300000,
    thanhPhan: "- Hoa cúc trắng: 15\n- Cát tường trắng: 5\n- Cẩm chướng trắng: 8\n- Hoa baby: 1",
    moTa: "Gentle Path dẫn lối với sắc trắng tinh tế và bình an. Bó hoa là biểu tượng cho một hành trình nhẹ nhàng, thanh thản — lời cầu chúc cho người ra đi được an nghỉ trong bình yên và tình yêu thương mãi còn hiện diện trong lòng những người ở lại.",
  },
  {
    id: "dip-30", ma: "flower36.webp", ten: "In Loving Memory", dip: "chia-buon", gia: 1500000,
    thanhPhan: "- Lan hồ điệp trắng: 3 cành\n- Hoa cúc trắng: 15\n- Cẩm chướng trắng: 10",
    moTa: "In Loving Memory là bó hoa chia buồn trang trọng và đầy xúc cảm, kết hợp lan hồ điệp với cúc trắng thuần khiết. Đây là lời tri ân cuối cùng và sâu sắc nhất, gửi gắm mọi yêu thương và ký ức đẹp đến người đã khuất.",
  },
  // Tốt nghiệp (flower37–42)
  {
    id: "dip-31", ma: "flower37.webp", ten: "Hy Vọng Thiên Thanh", dip: "tot-nghiep", gia: 200000,
    thanhPhan: "- Cẩm tú cầu: 1\n- Hoa đồng tiền trắng: 3",
    moTa: "Mang sắc xanh trong veo của bầu trời hòa cùng nét tinh khôi của những đóa đồng tiền trắng, bó hoa tựa như một lời chúc mừng thanh khiết cho những ước mơ vừa chạm ngưỡng trưởng thành. Cẩm tú cầu tượng trưng cho sự vẹn tròn của những tri thức đã gặt hái.",
  },
  {
    id: "dip-32", ma: "flower38.webp", ten: "Hoàng Kim Khát Vọng", dip: "tot-nghiep", gia: 400000,
    thanhPhan: "- Cát tường trắng: 2\n- Hồng vàng chùa: 3\n- Hồng Victo: 3\n- Lan vũ nữ: 1",
    moTa: "Sắc hồng vàng chùa và hồng Victo đan xen cùng cát tường trắng như gói trọn bao hoài bão và nỗ lực bền bỉ của những tháng năm đèn sách. Cành lan vũ nữ vươn cao thanh thoát, tựa như lời chúc về một tương lai linh hoạt và sự nghiệp thăng hoa.",
  },
  {
    id: "dip-33", ma: "flower39.webp", ten: "Hành Trình Mới", dip: "tot-nghiep", gia: 450000,
    thanhPhan: "- Hướng dương: 6\n- Lá khuynh diệp: 7",
    moTa: "Tựa như một lời hứa rạng rỡ về tương lai, bó hoa mang trong mình trọn vẹn tinh thần của những ngày tháng thanh xuân kiêu hãnh nhất. Những đóa hướng dương bung nở rực rỡ như những mặt trời nhỏ, đại diện cho ý chí quật cường và khát khao vươn tới những đỉnh cao mới.",
  },
  {
    id: "dip-34", ma: "flower40.webp", ten: "Hương Vị Trưởng Thành", dip: "tot-nghiep", gia: 650000,
    thanhPhan: "- Hồng Ecuador đỏ: 15\n- Cẩm chướng hồng: 8\n- Hoa baby: 1",
    moTa: "Hương Vị Trưởng Thành là dấu ấn của hành trình trưởng thành đầy tự hào. Những đóa hồng Ecuador đỏ kiêu hãnh kết hợp cùng cẩm chướng hồng dịu dàng tạo nên bó hoa tốt nghiệp đầy cảm xúc, gói trọn mọi nỗ lực và ước mơ của những năm tháng đèn sách.",
  },
  {
    id: "dip-35", ma: "flower41.webp", ten: "Tinh Tú Dẫn Lối", dip: "tot-nghiep", gia: 750000,
    thanhPhan: "- Cẩm chướng tím: 10\n- Hoa thạch thảo tím: 5\n- Hoa baby tím: 200g",
    moTa: "Tinh Tú Dẫn Lối mang sắc tím huyền bí và rực rỡ như những vì sao sáng trên bầu trời đêm. Bó hoa là lời chúc mừng tốt nghiệp đầy ý nghĩa, dẫn lối cho hành trình mới phía trước với niềm tin và khát vọng vươn cao không giới hạn.",
  },
  {
    id: "dip-36", ma: "flower42.webp", ten: "Khát Vọng Đan Thanh", dip: "tot-nghiep", gia: 1100000,
    thanhPhan: "- Hồng đỏ Ecuador: 15\n- Hoa ly trắng: 3\n- Cẩm chướng tím: 5\n- Hoa baby: 200g",
    moTa: "Khát Vọng Đan Thanh là bó hoa tốt nghiệp cao cấp, kết hợp hồng đỏ kiêu hãnh với ly trắng thanh cao. Mỗi bông hoa là một trang sách, mỗi cành là một chặng đường đã qua — tất cả kết tinh thành niềm tự hào và khát vọng chinh phục những đỉnh cao mới.",
  },
];

// ===== HOA HỢP TÚI =====
export const hoaHopTui = [
  // Dưới 250.000đ
  {
    id: "tui-1", ma: "flower19.webp", ten: "Pinky Muse", muc: "duoi-250k", gia: 150000,
    thanhPhan: "- Cúc mẫu đơn hồng nhạt: 1\n- Hoa baby: 1",
    moTa: "Pinky Muse là sự kết tinh của nét đẹp tối giản nhưng đầy chiều sâu, nơi một đóa cúc mẫu đơn hồng nhạt duy nhất tỏa sáng như một nữ hoàng kiêu sa ở vị trí trung tâm. Bó hoa là lựa chọn hoàn hảo để gửi gắm sự trân trọng và cầu chúc cho một tuổi mới luôn rạng ngời.",
  },
  {
    id: "tui-2", ma: "flower7.webp", ten: "Chân Thành", muc: "duoi-250k", gia: 180000,
    thanhPhan: "- Cẩm tú cầu xanh bơ: 3",
    moTa: "Chân Thành là biểu tượng của sự bền chặt và lòng tin tưởng tuyệt đối. Ba đóa cẩm tú cầu xanh bơ mang sắc thái dịu mát, đại diện cho sự hòa hợp, thấu hiểu và một tình cảm luôn tươi mới như thuở ban đầu.",
  },
  {
    id: "tui-3", ma: "flower20.webp", ten: "Nắng Mai", muc: "duoi-250k", gia: 200000,
    thanhPhan: "- Cúc Tana: 3\n- Hồng da: 5",
    moTa: "Nắng Mai là sự giao thoa ngọt ngào giữa vẻ đẹp cổ điển và nét hiện đại. 5 đóa hồng da mịn màng điểm xuyết cùng cúc Tana nhỏ xinh, mang lời cầu chúc cho tuổi mới luôn rạng rỡ và bình yên.",
  },
  {
    id: "tui-4", ma: "flower37.webp", ten: "Hy Vọng Thiên Thanh", muc: "duoi-250k", gia: 200000,
    thanhPhan: "- Cẩm tú cầu: 1\n- Hoa đồng tiền trắng: 3",
    moTa: "Mang sắc xanh trong veo của bầu trời hòa cùng nét tinh khôi của những đóa đồng tiền trắng, bó hoa tựa như một lời chúc mừng thanh khiết cho những ước mơ vừa chạm ngưỡng trưởng thành.",
  },
  // 250.000 – 500.000đ
  {
    id: "tui-5", ma: "flower8.webp", ten: "Cappuccino Vintage", muc: "250k-500k", gia: 250000,
    thanhPhan: "- Cẩm chướng chùm trắng: 3\n- Hồng capuchino: 4\n- Đồng tiền kem nhí: 3",
    moTa: "Cappuccino Vintage mang vẻ đẹp đầy lôi cuốn và hoài niệm với tông màu nâu kem đặc trưng. Bó hoa là món quà tri ân tinh tế dành cho những ai yêu thích phong cách sang trọng, cổ điển.",
  },
  {
    id: "tui-6", ma: "flower21.webp", ten: "Azure Dream", muc: "250k-500k", gia: 350000,
    thanhPhan: "- Cẩm tú cầu xanh: 5",
    moTa: "Tựa như một khoảng trời bình yên được gói ghém lại, Azure Dream mang đến sắc xanh dịu mắt của những đóa cẩm tú cầu bồng bềnh như mây. Không rực rỡ phô trương, bó hoa là món quà tinh tế dành tặng những tâm hồn giản đơn.",
  },
  {
    id: "tui-7", ma: "flower38.webp", ten: "Hoàng Kim Khát Vọng", muc: "250k-500k", gia: 400000,
    thanhPhan: "- Cát tường trắng: 2\n- Hồng vàng chùa: 3\n- Hồng Victo: 3\n- Lan vũ nữ: 1",
    moTa: "Sắc hồng vàng chùa và hồng Victo đan xen cùng cát tường trắng như gói trọn bao hoài bão và nỗ lực bền bỉ. Cành lan vũ nữ vươn cao thanh thoát, tựa như lời chúc về một tương lai linh hoạt và sự nghiệp thăng hoa.",
  },
  {
    id: "tui-8", ma: "flower9.webp", ten: "Roseberry", muc: "250k-500k", gia: 300000,
    thanhPhan: "- Green bell: 2\n- Hoa thạch thảo tím: 2\n- Hồng da: 10",
    moTa: "Roseberry là bản giao hưởng của sự thủy chung và lòng trân quý. Với 10 đóa hồng da làm chủ đạo, bó hoa tôn vinh một tình yêu bền chặt, đằm thắm và sự ngưỡng mộ sâu sắc.",
  },
  {
    id: "tui-9", ma: "flower39.webp", ten: "Hành Trình Mới", muc: "250k-500k", gia: 450000,
    thanhPhan: "- Hướng dương: 6\n- Lá khuynh diệp: 7",
    moTa: "Tựa như một lời hứa rạng rỡ về tương lai, bó hoa mang trong mình trọn vẹn tinh thần của những ngày tháng thanh xuân kiêu hãnh nhất. Những đóa hướng dương bung nở như những mặt trời nhỏ, đại diện cho ý chí vươn tới những đỉnh cao mới.",
  },
  {
    id: "tui-10", ma: "flower22.webp", ten: "The Pure Harmony", muc: "250k-500k", gia: 480000,
    thanhPhan: "- Cát tường xanh: 4\n- Cúc calimero trắng: 5\n- Hồng trắng cồ: 7",
    moTa: "The Pure Harmony mang hơi thở của thiên nhiên với sự đan xen hoàn hảo giữa sắc trắng tinh khôi và xanh lá tươi mát. Bó hoa thể hiện phong cách sống tinh tế, hiện đại và gần gũi với thiên nhiên.",
  },
  // 500.000 – 1.000.000đ
  {
    id: "tui-11", ma: "flower10.webp", ten: "Sweet Anniversary", muc: "500k-1000k", gia: 550000,
    thanhPhan: "- Cẩm chướng chùm hồng sen: 5\n- Cẩm chướng đơn viền tím: 7\n- Hồng da: 5\n- Purple Ohara: 5",
    moTa: "Sweet Anniversary mang tone hồng pastel nữ tính và thanh lịch. Sự hòa quyện giữa cẩm chướng hồng sen, cẩm chướng viền tím, hồng da và Purple Ohara tạo nên tổng thể vừa lãng mạn vừa cuốn hút.",
  },
  {
    id: "tui-12", ma: "flower40.webp", ten: "Hương Vị Trưởng Thành", muc: "500k-1000k", gia: 650000,
    thanhPhan: "- Hồng Ecuador đỏ: 15\n- Cẩm chướng hồng: 8\n- Hoa baby: 1",
    moTa: "Hương Vị Trưởng Thành là dấu ấn của hành trình trưởng thành đầy tự hào, gói trọn mọi nỗ lực và ước mơ của những năm tháng đèn sách trong từng cánh hoa.",
  },
  {
    id: "tui-13", ma: "flower11.webp", ten: "Whisper of Nature", muc: "500k-1000k", gia: 600000,
    thanhPhan: "- Cúc Tana: 3\n- Green wicky: 3\n- Hồng trắng cồ: 13\n- Scabiosa trắng: 3\n- Sen đá size trung: 1",
    moTa: "Whisper of Nature tôn vinh những mối quan hệ vững chãi vượt qua mọi thử thách thời gian, với hồng trắng cồ tinh khôi kết hợp cùng sen đá kiên cường.",
  },
  {
    id: "tui-14", ma: "flower25.webp", ten: "Hoàng Kim Khai Lộ", muc: "500k-1000k", gia: 750000,
    thanhPhan: "- Hướng dương: 5\n- Hoa ly vàng: 3\n- Lá khuynh diệp: 5",
    moTa: "Hoàng Kim Khai Lộ là biểu tượng của sự thịnh vượng và khởi đầu rực rỡ với hướng dương và hoa ly vàng sang trọng, mang ý nghĩa về một sự nghiệp phát đạt luôn hướng về phía ánh sáng.",
  },
  {
    id: "tui-15", ma: "flower31.webp", ten: "Silent Farewell", muc: "500k-1000k", gia: 600000,
    thanhPhan: "- Hoa cúc trắng: 15\n- Hoa baby trắng: 200g\n- Lá khuynh diệp xanh",
    moTa: "Silent Farewell mang vẻ đẹp thuần khiết và bình yên của sắc trắng, là sự đồng hành lặng lẽ nhưng đầy ý nghĩa trong những khoảnh khắc đau buồn nhất.",
  },
  {
    id: "tui-16", ma: "flower23.webp", ten: "Blush Harmony", muc: "500k-1000k", gia: 520000,
    thanhPhan: "- Hồng phấn: 8\n- Cẩm chướng hồng sen: 5\n- Hoa baby: 1",
    moTa: "Blush Harmony là sự hòa quyện ngọt ngào của sắc hồng phấn dịu dàng, tạo nên bó hoa nữ tính và đầy lãng mạn, thể hiện sự ngưỡng mộ và lời chúc ấm áp nhất.",
  },
  {
    id: "tui-17", ma: "flower12.webp", ten: "Mây Hồng Dịu Ngọt", muc: "500k-1000k", gia: 700000,
    thanhPhan: "- Cẩm tú cầu hồng: 3",
    moTa: "Bó hoa cẩm tú cầu hồng pastel mang vẻ đẹp nhẹ nhàng và tinh tế, như một áng mây mềm mại phủ sắc hồng dịu. Tượng trưng cho tình yêu thuần khiết và lòng biết ơn chân thành.",
  },
  {
    id: "tui-18", ma: "flower13.webp", ten: "Harmony of Gratitude", muc: "500k-1000k", gia: 750000,
    thanhPhan: "- Hoa baby: 1\n- Hồng da: 5\n- Hồng shimmer DL: 5\n- Hồng tím cà: 5\n- Hồng trắng cồ: 5\n- Hồng trứng gà: 5",
    moTa: "Harmony of Gratitude là bản hòa ca của lòng tri ân, kết tinh từ 25 đóa hồng mang những sắc thái rực rỡ nhất, tượng trưng cho sự trân trọng và gắn kết bền lâu.",
  },
  {
    id: "tui-19", ma: "flower24.webp", ten: "Nắng Hồng Rạng Rỡ", muc: "500k-1000k", gia: 520000,
    thanhPhan: "- Hướng dương mini: 3\n- Hồng vàng: 5\n- Cúc Tana cam: 3\n- Lá xanh phụ",
    moTa: "Nắng Hồng Rạng Rỡ bừng sáng với sắc vàng cam rực rỡ của hướng dương và hồng vàng, mang lời chúc một tuổi mới rạng ngời, hạnh phúc và luôn hướng về phía mặt trời.",
  },
  {
    id: "tui-20", ma: "flower26.webp", ten: "Vạn Lộc Khai Hoa", muc: "500k-1000k", gia: 850000,
    thanhPhan: "- Hoa cúc vàng: 10\n- Hồng đỏ: 5\n- Cát tường trắng: 3\n- Lá phụ",
    moTa: "Vạn Lộc Khai Hoa kết hợp sắc vàng và đỏ — màu sắc của may mắn và thịnh vượng. Bó hoa mang đến nguồn năng lượng tích cực và vạn điều hanh thông cho mọi khởi đầu.",
  },
  {
    id: "tui-21", ma: "flower41.webp", ten: "Tinh Tú Dẫn Lối", muc: "500k-1000k", gia: 750000,
    thanhPhan: "- Cẩm chướng tím: 10\n- Hoa thạch thảo tím: 5\n- Hoa baby tím: 200g",
    moTa: "Tinh Tú Dẫn Lối mang sắc tím huyền bí như những vì sao sáng, dẫn lối cho hành trình mới phía trước với niềm tin và khát vọng vươn cao không giới hạn.",
  },
  {
    id: "tui-22", ma: "flower32.webp", ten: "Lasting Memory", muc: "500k-1000k", gia: 700000,
    thanhPhan: "- Hoa cúc trắng: 10\n- Cẩm chướng trắng: 5\n- Hoa đồng tiền trắng: 3\n- Lá phụ",
    moTa: "Lasting Memory là bó hoa chia buồn mang màu trắng thanh tịnh. Mỗi bông hoa là một lời cầu nguyện chân thành — ký ức về người thân yêu sẽ mãi còn đó.",
  },
  {
    id: "tui-23", ma: "flower27.webp", ten: "Tĩnh Lam", muc: "500k-1000k", gia: 650000,
    thanhPhan: "- Cẩm tú cầu xanh: 3\n- Hoa lan xanh: 2 cành\n- Lá khuynh diệp: 5",
    moTa: "Tĩnh Lam mang vẻ đẹp thanh thoát và quý phái với sắc xanh tươi mát, tượng trưng cho sự bình tĩnh, trí tuệ và thành công bền vững trong mọi lĩnh vực.",
  },
  {
    id: "tui-24", ma: "flower14.webp", ten: "Eternal Flame", muc: "500k-1000k", gia: 950000,
    thanhPhan: "- Hồng đỏ Ecuador DL: 30",
    moTa: "Eternal Flame là biểu tượng của một tình yêu nồng cháy và không bao giờ lụi tàn với 30 đóa hồng đỏ Ecuador kiêu sa. Đây là món quà đầy đẳng cấp, khẳng định trái tim vẫn luôn hướng về bạn.",
  },
  {
    id: "tui-25", ma: "flower33.webp", ten: "Remembrance", muc: "500k-1000k", gia: 800000,
    thanhPhan: "- Hoa lan trắng: 2 cành\n- Cúc trắng: 8\n- Hoa baby trắng: 100g\n- Lá khuynh diệp",
    moTa: "Remembrance là sự kết hợp thanh lịch giữa lan trắng quý phái và cúc trắng bình dị, gửi gắm sự đồng cảm và yêu thương trong những ngày khó khăn nhất.",
  },
  // 1.000.000 – 2.000.000đ
  {
    id: "tui-26", ma: "flower15.webp", ten: "Sunset Glow", muc: "1000k-2000k", gia: 1100000,
    thanhPhan: "- Cẩm chướng đơn cam: 10\n- Green bell: 2\n- Hồng đỏ Ecuador DL: 15\n- Lan Moka vàng nến: 5\n- Lan Moka đỏ: 5\n- Sen đá lớn: 1",
    moTa: "Sunset Glow là một tuyệt tác rực rỡ, tượng trưng cho sự thịnh vượng và nguồn năng lượng bền bỉ. Sắc cam đỏ của hoàng hôn hòa quyện cùng nét thanh thoát của lan Moka tạo nên bó hoa cao cấp và ấn tượng.",
  },
  {
    id: "tui-27", ma: "flower28.webp", ten: "Xuân Phát", muc: "1000k-2000k", gia: 1200000,
    thanhPhan: "- Lan hồ điệp trắng: 3 cành\n- Hồng vàng: 10\n- Cẩm chướng cam: 5\n- Lá khuynh diệp",
    moTa: "Xuân Phát mang vẻ đẹp sang trọng với lan hồ điệp trắng — biểu tượng của sự thanh cao và thịnh vượng. Gửi gắm lời chúc cho một khởi đầu phát đạt, vạn sự như ý.",
  },
  {
    id: "tui-28", ma: "flower16.webp", ten: "Giấc Mơ Thạch Anh", muc: "1000k-2000k", gia: 1250000,
    thanhPhan: "- Cẩm chướng đơn viền tím: 10\n- Cát tường hồng viền: 2\n- Cúc calimero trắng: 5\n- Hoa baby: 1\n- Hồng song hỷ cồ: 10\n- Thúy châu trắng: 3",
    moTa: "Giấc Mơ Thạch Anh mang vẻ đẹp thanh lịch và đầy chất thơ với tông màu tím hồng dịu dàng, tôn vinh một tình cảm luôn tươi mới và tràn đầy hy vọng.",
  },
  {
    id: "tui-29", ma: "flower29.webp", ten: "Sắc Nắng", muc: "1000k-2000k", gia: 1400000,
    thanhPhan: "- Hồng cam Ecuador: 15\n- Hướng dương: 5\n- Cẩm chướng cam: 8\n- Lá bạc: 5",
    moTa: "Sắc Nắng bừng sáng với sắc cam rực rỡ, mang theo năng lượng của mặt trời và tinh thần lạc quan không ngừng. Tượng trưng cho sự nhiệt huyết, sáng tạo và thành công rực rỡ.",
  },
  {
    id: "tui-30", ma: "flower34.webp", ten: "Resting Heart", muc: "1000k-2000k", gia: 1100000,
    thanhPhan: "- Hoa cúc trắng: 20\n- Lan hồ điệp trắng: 1 cành\n- Hoa baby trắng: 200g",
    moTa: "Resting Heart là bó hoa chia buồn cao cấp, gửi gắm lời cầu nguyện bình yên và an ủi chân thành nhất đến những trái tim đang đau.",
  },
  {
    id: "tui-31", ma: "flower17.webp", ten: "Pink Romance", muc: "1000k-2000k", gia: 1300000,
    thanhPhan: "- Hồng hồng Ecuador cồ: 20\n- Hoa baby: 1\n- Lá khuynh diệp: 5",
    moTa: "Pink Romance là bản tình ca của những đóa hồng hồng Ecuador kiêu sa. Sắc hồng nồng nàn tượng trưng cho tình yêu đằm thắm, luôn tươi mới và đong đầy cảm xúc.",
  },
  {
    id: "tui-32", ma: "flower42.webp", ten: "Khát Vọng Đan Thanh", muc: "1000k-2000k", gia: 1100000,
    thanhPhan: "- Hồng đỏ Ecuador: 15\n- Hoa ly trắng: 3\n- Cẩm chướng tím: 5\n- Hoa baby: 200g",
    moTa: "Khát Vọng Đan Thanh kết hợp hồng đỏ kiêu hãnh với ly trắng thanh cao, kết tinh thành niềm tự hào và khát vọng chinh phục những đỉnh cao mới.",
  },
  {
    id: "tui-33", ma: "flower30.webp", ten: "Victory Aura", muc: "1000k-2000k", gia: 1600000,
    thanhPhan: "- Hồng đỏ Ecuador DL: 20\n- Hoa lily cam: 5\n- Hướng dương: 3\n- Lá bạc: 5",
    moTa: "Victory Aura là bó hoa đẳng cấp, kết hợp hồng đỏ kiêu sa với lily cam rực rỡ và hướng dương tươi vui — lời chúc mừng hoành tráng cho mọi khởi đầu đầy hứa hẹn.",
  },
  {
    id: "tui-34", ma: "flower35.webp", ten: "Gentle Path", muc: "1000k-2000k", gia: 1300000,
    thanhPhan: "- Hoa cúc trắng: 15\n- Cát tường trắng: 5\n- Cẩm chướng trắng: 8\n- Hoa baby: 1",
    moTa: "Gentle Path dẫn lối với sắc trắng tinh tế và bình an, là lời cầu chúc cho người ra đi được an nghỉ trong bình yên và tình yêu thương mãi còn hiện diện.",
  },
  {
    id: "tui-35", ma: "flower36.webp", ten: "In Loving Memory", muc: "1000k-2000k", gia: 1500000,
    thanhPhan: "- Lan hồ điệp trắng: 3 cành\n- Hoa cúc trắng: 15\n- Cẩm chướng trắng: 10",
    moTa: "In Loving Memory là bó hoa trang trọng và đầy xúc cảm, gửi gắm mọi yêu thương và ký ức đẹp đến người đã khuất — lời tri ân cuối cùng và sâu sắc nhất.",
  },
  // Trên 2.000.000đ
  {
    id: "tui-36", ma: "flower18.webp", ten: "Century of Love", muc: "tren-2000k", gia: 2200000,
    thanhPhan: "- Hồng đỏ Ecuador cồ: 50\n- Hoa baby: 2\n- Lá khuynh diệp: 8",
    moTa: "Century of Love là tuyên ngôn tình yêu hoành tráng nhất — 50 đóa hồng đỏ Ecuador cồ kiêu hãnh, tượng trưng cho một thế kỷ yêu thương không bao giờ phai nhạt. Món quà xa hoa dành cho những người xứng đáng nhận được điều tốt đẹp nhất.",
  },
];

// Helper: lấy ảnh hoa
// Ép Webpack quét toàn bộ file .webp trong thư mục flowers
// Ép Webpack quét toàn bộ file .webp
const context = require.context('./assets/flowers', false, /\.webp$/);

export const getFlowerImage = (ma) => {
  try {
    if (!ma) return null;

    // Chuẩn hóa tên file
    const cleanMa = ma.endsWith('.webp') ? ma : `${ma}.webp`;

    // Lấy module ảnh
    const imageModule = context(`./${cleanMa}`);
    return imageModule.default || imageModule;

  } catch (error) {
    console.warn(`Lỗi không tìm thấy ảnh: ${ma}`);
    return null; 
  }
};
// Helper: format giá VNĐ
export const formatGia = (gia) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(gia);

// Config dịp
export const dipConfig = {
  "ki-niem": {
    label: "Hoa Kỷ Niệm",
    icon: "💍",
    mauBadge: "#ff66a2",
    mauNen: "#fff0f5",
    moTaNgan: "Ghi dấu những khoảnh khắc đáng nhớ trong tình yêu và cuộc sống",
    banner: require("./assets/Hoa_dung_dip_banner/Hoa Kỷ Niệm.webp"),
  },
  "sinh-nhat": {
    label: "Hoa Sinh Nhật",
    icon: "🎂",
    mauBadge: "#ff8c42",
    mauNen: "#fff5ee",
    moTaNgan: "Gửi yêu thương và lời chúc tốt đẹp nhất trong ngày đặc biệt",
    banner: require("./assets/Hoa_dung_dip_banner/Hoa sinh nhật.webp"),
  },
  "khai-truong": {
    label: "Hoa Khai Trương",
    icon: "🎊",
    mauBadge: "#f4c430",
    mauNen: "#fffbea",
    moTaNgan: "Chúc mừng khởi đầu thịnh vượng và sự nghiệp phát đạt",
    banner: require("./assets/Hoa_dung_dip_banner/Hoa khai trương.webp"),
  },
  "chia-buon": {
    label: "Hoa Chia Buồn",
    icon: "🕯️",
    mauBadge: "#8a8a8a",
    mauNen: "#f5f5f5",
    moTaNgan: "Chia sẻ, đồng hành và gửi gắm lời an ủi chân thành",
    banner: require("./assets/Hoa_dung_dip_banner/Hoa chia buồn.webp"),
  },
  "tot-nghiep": {
    label: "Hoa Tốt Nghiệp",
    icon: "🎓",
    mauBadge: "#7c4dff",
    mauNen: "#f3eeff",
    moTaNgan: "Tôn vinh hành trình tri thức và chúc mừng chặng đường mới",
    banner: require("./assets/Hoa_dung_dip_banner/Hoa tốt nghiệp.webp"),
  },
};

// Config mức giá
export const mucGiaConfig = {
  "duoi-250k": { label: "Dưới 250.000đ", mau: "#4caf50", mauNen: "#f0fff0" },
  "250k-500k": { label: "250.000 – 500.000đ", mau: "#2196f3", mauNen: "#e8f4ff" },
  "500k-1000k": { label: "500.000 – 1.000.000đ", mau: "#ff8c42", mauNen: "#fff5ee" },
  "1000k-2000k": { label: "1.000.000 – 2.000.000đ", mau: "#9c27b0", mauNen: "#f9eeff" },
  "tren-2000k": { label: "Trên 2.000.000đ", mau: "#c8970a", mauNen: "#fffbe6" },
};
